import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  cardContainer: {
    borderRadius: 7,
    marginVertical: 10,
    overflow: 'hidden',
  },
  cardBody: {
    padding: 20,
    backgroundColor: colors.white,
  },
  cardBodyRoundedTopLeft: {
    borderTopLeftRadius: 5,
  },

  // ===== Header (shared) =====
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  //=== Inside Header (with icon inside) ===
  insideHeaderContainer: {
    paddingHorizontal: 20,
    paddingTop: 16,
    backgroundColor: colors.white,
  },
  insideHeaderTitleGroup: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  inlineIcon: {
    marginRight: 16,
  },

  //=== Outside Header (with icon outside) ===
  titleAndLinkContainer: {
    flex: 1,
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTopLeftRadius: 7,
    backgroundColor: colors.white,
  },
  iconBox: {
    width: 53,
    height: 53,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.newUI.therapist.bgBlue10,
  },
  title: {
    fontWeight: '600',
    fontSize: 20,
    color: colors.newUI.therapist.textBlue100,
  },

  icon: {
    color: colors.newUI.therapist.primaryBlue80,
    fontSize: 28,
  },
});
